import React, { useState } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import {
  Typography,
  Paper
} from '@material-ui/core';
import { push } from 'connected-react-router';
import {
  setChannelWorkflowGridStateUpdate,
  createExploreSystemView,
  setIsRedirectToExplore,
} from 'store/actions';
import { importModuleStateSelector } from 'store/selectors';
import { OpportunityImportItem, TitleImportItem, LogModal } from 'components/underwrite/acquisition/import/importStatus';
import { Constants } from 'utilities/constants';
import { GetAsgPropIdsWithImportId } from 'api/revue/import';

const ImportStatus = ({
  classes,
  importStatuses,
  push,
  setChannelWorkflowGridStateUpdate,
  createExploreSystemView,
  setIsRedirectToExplore,
}) => {
  const [logModalIsOpen, setLogModalIsOpen] = useState(false);
  const [logModalContent, setLogModalContent] = useState(null);

  function handleOpen(content) {
    setLogModalContent(content);
    setLogModalIsOpen(true);
  }

  function handleClose() {
    setLogModalIsOpen(false);
    setLogModalContent(null);
  }

  function handleRedirectToWorkflow(importId, channel) {
    setChannelWorkflowGridStateUpdate({ filterValue: [['importId', '=', importId]], columnMods: [{ field: 'id', type: 'sortOrder', value: 'asc' }] }, true);
    push(Constants.Routes.CHANNEL_WORKFLOW);
  }

  function handleRedirectToExplore(importItem) {
    GetAsgPropIdsWithImportId(importItem.importDbId)
      .then(asgPropIDs => {
        // construct filterValue
        const filterValue = ['asgPropID', 'in', asgPropIDs];
        // construct filterExpression to display on UI
        const filterExpression = [];
        asgPropIDs.forEach(id => {
          filterExpression.push(['asgPropID', '=', id]);
          filterExpression.push('or');
        });
        filterExpression.pop();
        const newFilter = { filterValue, filterExpression };
        createExploreSystemView(`Opp Import '${importItem.importName}'`, newFilter);
        // fire redirect
        push(Constants.Routes.EXPLORE);
      }).catch(error => {
        console.log(error.message);
      });
  }

  function handleTitlesRedirect(txnOppIds) {
    setChannelWorkflowGridStateUpdate({ filterValue: [['id', 'anyof', txnOppIds]], columnMods: [{ field: 'id', type: 'sortOrder', value: 'asc' }] }, true);
    push(Constants.Routes.CHANNEL_WORKFLOW);
  }

  return (
    <div className={classes.root}>
      {
        Object.values(importStatuses).length > 0
          ? Object.values(importStatuses).reverse().map((importItem) => {
            return importItem.importType && importItem.importType === Constants.ImportType.TITLES
              ? <TitleImportItem key={importItem.importId} importItem={importItem} handleTitlesRedirect={handleTitlesRedirect} />
              : <OpportunityImportItem key={importItem.importId} importItem={importItem} handleRedirectToWorkflow={handleRedirectToWorkflow} handleRedirectToExplore={handleRedirectToExplore} handleOpen={handleOpen} />
          })
          : <div className={classes.itemContainer}>
            <Paper className={classes.noImports}>
              <Typography variant='subtitle2'>There are no imports</Typography>
            </Paper>
          </div>
      }
      <LogModal open={logModalIsOpen} content={logModalContent} handleClose={handleClose} />
    </div>
  )
}

const styles = theme => ({
  root: {
    flexGrow: 1,
  },
  itemContainer: {
    marginBottom: theme.spacing(1.5),
  },
  noImports: {
    height: 75,
    width: 460,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }
});

const mapStateToProps = (state) => {
  const underwriteState = importModuleStateSelector(state, Constants.Module.UNDERWRITE);
  return {
    importStatuses: underwriteState.importStatuses
  }
}
const mapDispatchToProps = {
  push,
  setChannelWorkflowGridStateUpdate,
  setIsRedirectToExplore,
  createExploreSystemView
};
export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps)
)(ImportStatus);
